<template>
	<main>
		<header>
			<div class="mb-8 vx-row mx-0 w-full justify-center items-center">
				<div class="vx-col w-full md:w-1/3 mb-3 md:mb-0">
					<vs-button type="filled" class="w-full" size="large" @click.prevent="showPaymentGateway('va')">
						<small>Virtual Account</small>
					</vs-button>
				</div>
				<div class="vx-col w-full md:w-1/3">
					<vs-button type="border" class="w-full" size="large" @click.prevent="showPaymentGateway('other')">
						<small>Lainnya</small>
					</vs-button>
				</div>
			</div>
		</header>
		<section>
			<div class="vx-row mx-4 mb-12">
				<slot name="content" :items="paymentGateways">
					<div 
					    class="vx-col w-full rounded-lg mb-6"
					 	v-for="(item, i) in paymentGateways"
					    :key="i"
					    style="border: 1px solid #ccc;cursor: pointer;"
					>
						<div class="vx-row py-4 px-2 items-center">
							<div class="vx-col w-1/4 md:w-1/6">
								<img v-if="item.file === null" :src="`/assets/images/payment_method/${item.code}.png`" alt="" class="w-12 md:w-16 block text-left" />
								<img v-else :src="item.file" alt="" class="w-12 md:w-16 block text-left" />
							</div>
							<div class="vx-col w-1/2 md:w-2/3">
								<h5 class="text-left text-sm md:text-md lg:text-lg">
									<strong>{{item.name}}</strong>
								</h5>
							</div>
							<div class="vx-col w-1/4 md:w-1/6 text-right">
								<vs-radio :vs-value="item.id" v-model="selectedPayment">
							</vs-radio>
							</div>
						</div>
					</div>
				</slot>
			</div>
		</section>
	</main>
</template>
<script>
	export default {
		props: ['paymentGateways'],
		data: () => ({
			selectedPayment: null
		}),
		methods: {
			showPaymentGateway (typePayment) {
				this.$emit('changeTypePayment', typePayment)
		    }
		},
		watch: {
			selectedPayment(val) {
				if(val) {
					this.$emit('selected', val)
				}
			}
		}
	}
</script>